import React, { useState } from 'react'
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap"
import Message from '../../../../components/Common/Message';
import { useBoolean } from '@fluentui/react-hooks';
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import MasterKpiInfo from './MasterKpiInfo';
import { _global_buttonStyles } from '../../../../common/ObjectStructures/Trasnversal';
import CTextBox from "../../../../components/Common/CTextBox";
import { useOnSearchMasterKpi } from '../../../../hooks/component/sKPI/Maintainers/useMaintainerVariable';

function SidePanelSelectMasterKpi(props) {
    const { t } = useTranslation();
    
    //Parametros de entrada.
    const inputParam_IsPanelOpen = props.isPanelOpen;
    const inputParam_SetterIsPanelOpen = props.setterIsPanelOpen;
    const inputParam_SetterMasterKpiIdOnList = props.setterMasterKpiIdOnList;
    const inputParam_MasterKpiSelected = props.masterKpiSelected;
    const inputParam_VariableId = props.variableId;
    const inputParam_ListMasterKpis = props.listMasterKpis.data ? props.listMasterKpis.data : { data : props.listMasterKpis };
    
    //Parametros de componente.
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    
    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState(null);
    const [showMessage, setShowMessage] = useState(false);

    const [searchManager, setSearchManager] = useState({text: "", fireSearch: false});
  
    const [masterKpiId, setMasterKpiId] = useState(null);
    const [masterKpiSelected, setMasterKpiSelected] = useState(inputParam_MasterKpiSelected);
 

    const [hideActionButtons, setHideActionButtons] = useState(false);



    const [listMasterKpisAux, setListMasterKpisAux] = useState({data: null, orderAsc: null, orderField: null, pageNumber: 1, fireUpdate: true, pageSize: 900, filters: []});
    useOnSearchMasterKpi(searchManager, inputParam_ListMasterKpis.data, setSearchManager, setListMasterKpisAux)

    const selectMasterKpiCurrentAndParentComponent = (mKpi) => {
        setMasterKpiSelected(mKpi)
        setMasterKpiId(mKpi.id)
    }

    const onSelectMasterKpi = () => {
        if (masterKpiId !== null) {
                inputParam_SetterMasterKpiIdOnList && inputParam_SetterMasterKpiIdOnList(
                    masterKpiId,
                    "masterKpiId_" + inputParam_VariableId,
                    masterKpiSelected
                );

                onClosePanel();
        } else {
            setShowMessage(true)
            setMessageType("warning");
            setMessage(t('data-lang-msg-requireddatanotset'))
        }
    };

    const onClosePanel = () => {
        onDismissPanel();
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);

        setMessage(null);
        setMessageType(null);
        setShowMessage(false);

        setHideActionButtons(false);

        setMasterKpiId(null);
    };

    const onSearch = (controlValue) => {
        if (controlValue === "") {
            setListMasterKpisAux(prevState => ({
                ...prevState,
                data: null
            }));
            
            setSearchManager({
                text: controlValue,
                fireSearch: false
            })
        }
        else {
            setSearchManager({
                text: controlValue,
                fireSearch: true
            })
        }
    };

    const onRenderFooterContent = () => {
        return <div className='d-flex'>
            {
                hideActionButtons === false &&
                <PrimaryButton
                    onClick={ () => onSelectMasterKpi() }
                    styles={_global_buttonStyles}>{ t('data-lang-btn-select') }
                </PrimaryButton>
            }
            <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
        </div>
    };

    //Render de componente.
    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-selectmasterkpi') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <Row className="pt-3">
                    <Col xl={12}>
                        <CTextBox labelText={t('data-lang-lbl-search')} controlValue={searchManager.text} setterControlValue={onSearch} />
                    </Col>
                </Row>
                <Row className="pt-3">
                    <Col xl={12}>
                        {
                            inputParam_ListMasterKpis.data !== null && (listMasterKpisAux.data !== null ? listMasterKpisAux : inputParam_ListMasterKpis).data.map((mKpi, index) =>
                                <MasterKpiInfo
                                    key={index}
                                    objMasterKpi={mKpi}
                                    masterKpiSelected={masterKpiSelected}
                                    setterMasterKpi={selectMasterKpiCurrentAndParentComponent}
                                /> 
                            )
                        }
                    </Col>
                </Row>

                <Row>
                    <Col className="message-verybottom-panel-medium-message">
                        <Message message={ message } display={ showMessage === null? false : showMessage } messageType={ messageType } setterShowMessage={ setShowMessage } />
                    </Col>
                </Row>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
}

export default SidePanelSelectMasterKpi;